import { Navigate, Route } from 'react-router';

import App from 'App';
import EighteenT from 'pages/18T/18T';
import { Homepage } from './pages/Homepage/Homepage';
import Info from 'pages/Info/Info';

export const DefaultRoutes = {
  Home: '/',
  Info: '/info',
  EighteenT: '/18T',
} as const;

export const routes = (
  <Route element={<App />}>
    <Route path={DefaultRoutes.Home} element={<Homepage />} />
    <Route path={DefaultRoutes.Info} element={<Info />} />
    <Route path={DefaultRoutes.EighteenT} element={<EighteenT />} />
    <Route path='*' element={<Navigate to={DefaultRoutes.Home} replace />} />
  </Route>
);
